import axios from 'axios';

export const request = (query: {}, variables: {} = {}) => {
    let storeCode = 'default';
    
    if (typeof window !== 'undefined') {
        storeCode = window.STORE_CODE || 'default';
    }
    
    return axios({
        method: 'POST',
        url: '/graphql',
        headers: {
            'Content-Type': 'application/json',
            'Store': storeCode,
        },
        data: {
            query: query,
            variables: variables
        }
    }).then(response => {
        return response.data;
    })
        .catch(error => {
            throw error.response.data;
        });
};
